import { useState, useEffect } from 'react';
import { queryCampaign } from '@/service/service-renewal';
import type { CampaignInfo } from './types';

interface UseCampaignReturn {
    campaignId: number | null;
    campaignName: string;
    loading: boolean;
    error: string | null;
}

/**
 * 查询当前站点换新活动信息，页面挂载时自动请求
 */
export const useCampaign = (locale: string): UseCampaignReturn => {
    const [campaignId, setCampaignId] = useState<number | null>(null);
    const [campaignName, setCampaignName] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!locale) return;

        const fetchCampaign = async () => {
            setLoading(true);
            setError(null);
            try {
                const res = await queryCampaign(locale);
                const data: CampaignInfo = res?.data;
                if (data) {
                    setCampaignId(data.campaignId);
                    setCampaignName(data.name);
                }
            } catch (err: any) {
                setError(err?.message ?? 'Failed to load campaign');
            } finally {
                setLoading(false);
            }
        };

        fetchCampaign();
    }, [locale]);

    return { campaignId, campaignName, loading, error };
};
